import { render, staticRenderFns } from "./cModalAddDataPdfLiquidacion.vue?vue&type=template&id=72e31be2&scoped=true"
import script from "./cModalAddDataPdfLiquidacion.vue?vue&type=script&lang=js"
export * from "./cModalAddDataPdfLiquidacion.vue?vue&type=script&lang=js"
import style0 from "./cModalAddDataPdfLiquidacion.vue?vue&type=style&index=0&id=72e31be2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "72e31be2",
  null
  
)

export default component.exports